






























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import SwxNumberInput from "@/components/SwxNumberInput.vue";
import { Status } from "@/modules/simulator/store";
const { State, Action } = namespace("julho_14/simulator");

@Component({
    components: {
        SwxNumberInput
    }
})
export default class QuotaInfo extends Vue {
    @State("quota_flux")
    public readonly quotaFlux!: number;

    @State("quota_downstream")
    public readonly quotaDownstream!: number;

    @State
    public readonly status!: Status;

    get disabled(): boolean {
        return this.status === Status.running;
    }

    @Action
    public readonly updateData!: (data: {
        [key: string]: number;
    }) => Promise<void>;

    update(value: number, name: string) {
        this.updateData({
            [name]: value
        });
    }
}
